import { User } from "oidc-client-ts";
import { cognitoConfig } from "../CognitoConfig";

// Defensa del cliente: la API sigue siendo responsable de validar firma y permisos.
export async function sessionAuthorization(config) {
  const key = `user:${cognitoConfig.authority}:${cognitoConfig.client_id}`;
  let user;
  try {
    const stored = await cognitoConfig.userStore.get(key);
    user = stored ? User.fromStorageString(stored) : null;
  } catch {
    throw new Error("Sesión inválida. Inicia sesión nuevamente.");
  }

  // Conservamos el tipo de token que utilizan actualmente estas APIs.
  const token = user?.id_token || user?.access_token;
  if (
    !Number.isFinite(user?.expires_at) ||
    user?.expired !== false ||
    typeof token !== "string" ||
    !token.trim()
  ) {
    throw new Error("Se requiere una sesión vigente. Inicia sesión nuevamente.");
  }

  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}
